import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Layout from './components/Layout';
import Home from './pages/Home';
import AllArt from './pages/AllArt';
import ArtworkDetail from './components/ArtworkDetail';
import About from './pages/About';
import CV from './pages/CV';
import AdminQuotes from './pages/AdminQuotes';
import styled from 'styled-components';
import React from 'react';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// News pages
import ExhibitionLondon from './pages/news/ExhibitionLondon';
import ExhibitionMiami from './pages/news/ExhibitionMiami';
import ExhibitionSothebys from './pages/news/ExhibitionSothebys';
import ExhibitionPeru from './pages/news/ExhibitionPeru';
import NewsICVA from './pages/news/NewsICVA';
import MapsOfHyperspaceDocumentary from './pages/news/MapsOfHyperspaceDocumentary';
import ShopOpening from './pages/news/ShopOpening';
import FabukMagazineReview from './pages/news/FabukMagazineReview';

// Article pages
import AmazonDiaries from './pages/articles/AmazonDiaries';
import BoyAndPlant from './pages/articles/BoyAndPlant';
import OntologicalQuest from './pages/articles/OntologicalQuest';
import Portals from './pages/articles/Portals';
import SecretWorld from './pages/articles/SecretWorld';

// Interview pages
import OneArtistOneArtworkInterview from './pages/interviews/OneArtistOneArtworkInterview';
import GokuAndSleeprInterview from './pages/interviews/GokuAndSleeprInterview';
import DanAndSleeprInterview from './pages/interviews/DanAndSleeprInterview';
import FabukMagazine from './pages/interviews/FabukMagazine';
import BehindTheArt from './pages/interviews/BehindTheArt';
import ODKAndSleeprInterview from './pages/interviews/ODKAndSleeprInterview';
import SolCityAndSleeprInterview from './pages/interviews/SolCityAndSleeprInterview';
import PedroAndSleeprInterview from './pages/interviews/PedroAndSleeprInterview';
import BoogleAndSleeprInterview from './pages/interviews/BoogleAndSleeprInterview';
import PenguAndSleeprInterview from './pages/interviews/PenguAndSleeprInterview';
import ShakeAndSleeprInterview from './pages/interviews/ShakeAndSleeprInterview';

console.log('App module is loading');

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
`;

const PageTransition = styled.div`
  position: relative;
  animation: pageFadeIn 0.35s ease-out;

  @keyframes pageFadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 6px;
    background: #000;
    opacity: 0.12;
    transform: scaleX(0);
    transform-origin: left center;
    animation: swipeIn 0.4s ease-out;
  }

  &::before {
    top: 0;
  }

  &::after {
    bottom: 0;
    animation-delay: 0.05s;
  }

  @keyframes swipeIn {
    from {
      transform: scaleX(0);
    }
    to {
      transform: scaleX(1);
    }
  }
`;

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <PageTransition key={location.pathname}>
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/art" element={<AllArt />} />
        <Route path="/art/:slug" element={<ArtworkDetail />} />
        <Route path="/about" element={<About />} />
        <Route path="/cv" element={<CV />} />
        
        {/* News Routes */}
        <Route path="/news/icva-partnership-2025" element={<NewsICVA />} />
        <Route path="/news/solo-exhibition-london-2024" element={<ExhibitionLondon />} />
        <Route path="/news/art-basel-miami-2023" element={<ExhibitionMiami />} />
        <Route path="/news/sothebys-hong-kong-2023" element={<ExhibitionSothebys />} />
        <Route path="/news/the-amazon-peru-2025" element={<ExhibitionPeru />} />
        <Route path="/news/maps-of-hyperspace-documentary" element={<MapsOfHyperspaceDocumentary />} />
        <Route path="/news/shop-opening" element={<ShopOpening />} />
        <Route path="/news/fabuk-magazine-london-exhibition-review" element={<FabukMagazineReview />} />

        {/* Article Routes */}
        <Route path="/articles/the-amazon-diaries-a-month-studying-plant-spirits" element={<AmazonDiaries />} />
        <Route path="/articles/the-boy-and-the-plant" element={<BoyAndPlant />} />
        <Route path="/articles/the-secret-world-of-sleepr" element={<SecretWorld />} />
        <Route path="/articles/sleeprs-secret-ontological-quest" element={<OntologicalQuest />} />
        <Route path="/articles/portals-accessing-and-storing-information-in-quantum-folders" element={<Portals />} />

        {/* Interview Routes */}
        <Route path="/interviews/one-artist-one-artwork-interview" element={<OneArtistOneArtworkInterview />} />
        <Route path="/interviews/goku-and-sleepr-interview" element={<GokuAndSleeprInterview />} />
        <Route path="/interviews/dan-and-sleepr-interview" element={<DanAndSleeprInterview />} />
        <Route path="/interviews/fabuk-magazine-the-secrets-show" element={<FabukMagazine />} />
        <Route path="/interviews/behind-the-art-interview-and-profile" element={<BehindTheArt />} />
        <Route path="/interviews/odk-and-sleepr-interview" element={<ODKAndSleeprInterview />} />
        <Route path="/interviews/sol-city-and-sleepr-interview" element={<SolCityAndSleeprInterview />} />
        <Route path="/interviews/pedro-and-sleepr-interview" element={<PedroAndSleeprInterview />} />
        <Route path="/interviews/boogle-and-sleepr-interview" element={<BoogleAndSleeprInterview />} />
        <Route path="/interviews/pengu-and-sleepr-interview" element={<PenguAndSleeprInterview />} />
        <Route path="/interviews/shake-and-sleepr-interview" element={<ShakeAndSleeprInterview />} />

        <Route path="/admin/quotes" element={<AdminQuotes />} />
      </Routes>
    </PageTransition>
  );
};

function App() {
  console.log('App component is rendering');

  return (
    <Router>
      <ScrollToTop />
      <AppContainer>
        <Navbar />
        <MainContent>
          <Layout>
            <AnimatedRoutes />
          </Layout>
        </MainContent>
        <Footer />
      </AppContainer>
    </Router>
  );
}

console.log('App component defined');

export default App; 